import { render, staticRenderFns } from "./SamlSettingCard.vue?vue&type=template&id=b8230610&scoped=true"
import script from "./SamlSettingCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SamlSettingCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SamlSettingCard.vue?vue&type=style&index=0&id=b8230610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8230610",
  null
  
)

export default component.exports